import LocationListItemSkeleton from "./LocationListItemSkeleton";
import LocationListItemContent from "./LocationListItemContent";
import React, { Suspense } from "react";

function LocationListItem({ gameId }) {
  return (
    <Suspense fallback={<LocationListItemSkeleton />}>
      <LocationListItemContent gameId={gameId} />
    </Suspense>
  );
}

export default LocationListItem;
